import styled from "@emotion/styled";
import { BaseCell } from "src/components/Table/Cells/shared";

const CellContainer = styled(BaseCell)`
  font-family: monospace, monospace;
`;

interface IDCellProps {
  id: string;
}

export const IDCell = ({ id }: IDCellProps) => (
  <CellContainer>{id.substring(4)}</CellContainer>
);
